import {
  type Colors,
  type ThemeConfig,
  extendTheme,
  withDefaultColorScheme,
} from '@chakra-ui/react';

import { buttonTheme } from './components/button';
import { inputTheme } from './components/input';

const config: ThemeConfig = {
  initialColorMode: 'light',
  useSystemColorMode: false,
};

export const BRAND_BLACK_COLOR = '#000000';
export const BRAND_GRAY_COLOR = '#E3E3E3';
export const BRAND_WHITE_COLOR = '#ffffff';
export const BRAND_RED_COLOR = '#d60000';
export const BRAND_ORANGE_COLOR = '#d66b00';
export const BRAND_BACKGROUND_COLOR = BRAND_WHITE_COLOR;
export const BRAND_GREEN_COLOR = '#3cb692';
export const BRAND_SAND_COLOR = '#fef7f4';

const breakpoints = {
  base: '0em', // 0px
  sm: '30em', // ~480px. em is a relative unit and is dependant on the font size.
  md: '48em', // ~768px
  lg: '64em', // ~992px
  xl: '80em', // ~1280px
  '2xl': '96em', // ~1536px
};

const colors: Colors = {
  brand: BRAND_GRAY_COLOR,
  gray: BRAND_GRAY_COLOR,
  grayLighter: `${BRAND_GRAY_COLOR}1A`, // 15% opacity
  grayLight: `${BRAND_GRAY_COLOR}4D`, // 30% opacity
  grayDark: `${BRAND_GRAY_COLOR}99`, // 60% opacity
  grayDarker: `${BRAND_GRAY_COLOR}CC`, // 80% opacity
  green: BRAND_GREEN_COLOR,
  greenLight: `${BRAND_GREEN_COLOR}4D`, // 30% opacity
  greenDark: `${BRAND_GREEN_COLOR}99`, // 60% opacity
  greenDarker: `${BRAND_GREEN_COLOR}CC`, // 80% opacity
  white: BRAND_WHITE_COLOR,
  black: BRAND_BLACK_COLOR,
};

const fonts = {
  body: 'OPEN SANS, sans-serif',
  heading: 'Abhaya Libre, sans-serif',
};

const styles = {
  global: {
    body: {
      fontFamily: 'body',
      bg: BRAND_BACKGROUND_COLOR,
      color: BRAND_BLACK_COLOR,
    },
  },
};

export const THEME = extendTheme(
  {
    colors,
    config,
    styles,
    fonts,
    breakpoints,
    components: {
      Input: inputTheme,
      Button: buttonTheme,
    },
  },
  withDefaultColorScheme({ colorScheme: 'brand' }),
);
